import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
import GlobalStyles from './globalStyles';
import customShadows from './customShadows';
import componentsOverride from './overrides';
import { PRIMARY_POWER } from './palette'; 
// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const domain = window.location.hostname; // Get current hostname

  const themeOptions = useMemo(() => {
    let currentPalette = { ...palette };
    console.log('domain is: ' + process.env.REACT_APP_POWER_BET_ADDRESS + '-> ' + domain);
    console.log(domain.includes(process.env.REACT_APP_POWER_BET_ADDRESS));
    if (domain.includes(process.env.REACT_APP_POWER_BET_ADDRESS)) {
      // Apply only the primary, secondary, and error colors for power.localhost
      currentPalette = {
        ...palette,
        primary: PRIMARY_POWER,
        secondary: PRIMARY_POWER,
        error: PRIMARY_POWER,
      };
    }

    // Rest of the palette stays intact
    return {
      palette: currentPalette,
      shape: { borderRadius: 6 },
      typography,
      shadows: shadows(),
      customShadows: customShadows(),
    };
  }, [domain]);

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
